/* NOTE HEADER SLIDERS START */

const slides = document.querySelectorAll(".main-product-slide");
const next = document.querySelector("#slideNext");
const prev = document.querySelector("#slidePrev");

// global variables for scrolling
const auto = false;
const hasBtns = false;
const intervalTime = 10000; //ms
let slideInterval;

// set initial slide to 0
slides[0]?.classList.add("current-product");

/**
 * @function navSlider
 * @description controls which slide is current and updates indicator value
 */
function navSlider() {
    const slides = document.querySelectorAll(".main-product-slide");
    const navSlider = document.querySelectorAll(".main-product-slider-nav-slide");

    for (let i = 0; i < navSlider.length; i++) {
        const element = navSlider[i];

        element.addEventListener("click", () => {
            const slide = document.querySelector(".current-product");
            slide.classList.remove("current-product");
            slides[i].classList.add("current-product");

            const indicator = document.querySelectorAll(".indicator-dot-product");
            const dot = document.querySelector(".indicator-dot-active");
            dot.classList.remove("indicator-dot-active");
            indicator[i].classList.add("indicator-dot-active");
        });
    }
}

navSlider();

/**
 * @function indicatorSlide
 * @description navigate to the slide when indicator is clicked
 */
function indicatorSlide() {
    const indicator = document.querySelector(".main-product-btns-indicator");
    // slides[0].classList.add('current')

    for (let i = 0; i < slides.length; i++) {
        const element = slides[i];

        // creates a dot for each slide
        const dot = document.createElement("span");
        dot.classList.add("indicator-dot-product");
        indicator.appendChild(dot);

        // when dot is clicked move to slide
        dot.addEventListener("click", () => {
            const current = document.querySelector(".current-product");
            current.classList.remove("current-product");
            element.classList.add("current-product");
            navSlider();
        });
    }

    // adding functionality for dot styling
    const dots = document.querySelectorAll(".indicator-dot-product");
    dots[0].classList.add("indicator-dot-active");

    for (let i = 0; i < dots.length; i++) {
        const element = dots[i];

        // when dot element is click remove previous dot class and add new
        element.addEventListener("click", () => {
            const current = document.querySelector(".indicator-dot-active");
            current.classList.remove("indicator-dot-active");
            element.classList.add("indicator-dot-active");
        });
    }
}

/**
 * @function nextSlide
 * @description navigate to the next slide
 */
function nextSlide() {
    const current = document.querySelector(".current-product");
    if (current.nextElementSibling) {
        current.nextElementSibling.classList.add("current-product");
    } else {
        slides[0].classList.add("current");
    }
    setTimeout(() => current.classList.remove("current-product"));
}

/**
 * @function prevSlide
 * @description navigate to the previous slide
 */
function prevSlide() {
    const current = document.querySelector(".current-product");

    if (current.previousElementSibling) {
        current.previousElementSibling.classList.add("current-product");
    } else {
        slides[slides.length - 1].classList.add("current-product");
    }
    setTimeout(() => current.classList.remove("current-product"));
}

// if the slider has buttons
if (hasBtns) {
    next.addEventListener("click", (e) => {
        nextSlide();
        if (auto) {
            clearInterval(slideInterval);
            slideInterval = setInterval(nextSlide, intervalTime);
        }
    });
    prev.addEventListener("click", (e) => {
        prevSlide();
        clearInterval(slideInterval);
        slideInterval = setInterval(nextSlide, intervalTime);
    });
} else {
    if (slides.length > 1) {
        indicatorSlide();
    }
    //   next.style.display = "none";
    //   prev.style.display = "none";
}

// auto slider
if (auto) {
    // document.querySelector('.main-product-btns').style.display = "none"
    slideInterval = setInterval(nextSlide, intervalTime);
}

/**
 * @function zoomProduct
 * @description Enables zoom funcationlity on current product item.
 */
function zoomProduct() {
    const slideBtns = document.querySelector(".main-product-btns");
    const sliderPage = document.querySelectorAll(".slider-btns");

    const slides = document.querySelectorAll(".main-product-slide");
    const zoomedSlide = document.querySelectorAll(".zoomed-slider");

    const zoomNav = document.querySelector(".zoom-slider-nav");
    const zoomClose = document.querySelector(".zoomed-slider-close");

    for (let i = 0; i < slides.length; i++) {
        const slide = slides[i];

        slide.addEventListener("click", () => {
            slideBtns.classList.toggle("toggle-opactity");

            sliderPage.forEach((slide) => {
                slide.classList.toggle("toggle-opactity");
            });

            zoomClose.classList.toggle("zoomed-slider-close__show");
            zoomNav.classList.toggle("zoom-slider-nav__show");
            for (let index = 0; index < zoomedSlide.length; index++) {
                const zoom = zoomedSlide[index];
                zoom.classList.toggle("main-product__zoom-in");
            }
        });
    }
}

zoomProduct();

/**
 * closeZoomedDiv
 * closes the currently zoomed div
 */
function closeZoomedDiv() {
    const slideBtns = document.querySelector(".main-product-btns");
    const sliderPage = document.querySelectorAll(".slider-btns");

    const close = document.querySelector(".zoomed-slider-close");
    const slides = document.querySelectorAll(".zoomed-slider");
    const zoomNav = document.querySelector(".zoom-slider-nav");
    close?.addEventListener("click", () => {
        slideBtns.classList.toggle("toggle-opactity");

        sliderPage.forEach((slide) => {
            slide.classList.toggle("toggle-opactity");
        });

        window.scrollTo({top: 0, behavior: "smooth"});
        slides.forEach((slide) => {
            slide.classList.remove("main-product__zoom-in");
        });
        close.classList.remove("zoomed-slider-close__show");
        zoomNav.classList.remove("zoom-slider-nav__show");
        // current-product
        // zoomed-slider-close__show
    });
}

closeZoomedDiv();

/**
 * plusSlides
 * gets current slide value and passes it to showSlides
 * @param {*} n -- current slide number
 */
function plusSlides(n) {
    showSlides((slideIndex += n));
}

/**
 * showSlides
 * show/hide next/prev slides
 * @param {n} n -- current slide number
 */
function showSlides(n) {
    let i;
    let slides = document.getElementsByClassName("main-product-slide");

    if (n > slides.length) {
        slideIndex = 1;
    }
    if (n < 1) {
        slideIndex = slides.length;
    }

    for (i = 0; i < slides.length; i++) {
        slides[i].classList.remove("current-product");
    }
    slides[slideIndex - 1].classList.add("current-product");

    const indicators = document.querySelectorAll(".indicator-dot-product");
    const dot = document.querySelector(".indicator-dot-active");

    indicators.forEach((indicator, i) => {
        if (i === slideIndex - 1) {
            indicator.classList.toggle("indicator-dot-active");
        } else {
            indicator.classList.remove("indicator-dot-active");
        }
    });
}

/**
 * @function checkedVariant
 * @description handles the styling of the parent block once a radioio button has been selected
 */
function checkedVariant() {
    const radios = document.querySelectorAll(".main-product__radio-btn");
    const selections = document.querySelectorAll(
        ".main-product__radio-selections"
    );

    // initial view
    for (let i = 0; i < radios.length; i++) {
        const check = radios[i];
        if (check.checked) {
            check.parentNode.classList.add("main-product__radio-selected");
        }
    }

    // click event for radios
    for (var i = 0; i < radios.length; i++) {
        const radio = radios[i];

        radio.addEventListener("click", () => {
            if (radio.checked) {
                radio.parentNode.classList.add("main-product__radio-selected");
            }

            for (let i = 0; i < selections.length; i++) {
                const select = selections[i];

                if (!select.children[0].checked) {
                    select.classList.remove("main-product__radio-selected");
                }
            }
        });
    }
}

checkedVariant();

/**
 * @function productAccordion
 * @description accordion to show and hide content on click
 */
function productAccordion() {
    const btns = document.querySelectorAll(".lr-product__btn");
    const tabs = document.querySelectorAll(".lr-product__tab");

    if (tabs.length > 0) tabs[0].style.display = "block";
    if (btns.length > 0) btns[0].classList.add("lr-product__btn-active");

    for (let i = 0; i < btns.length; i++) {
        const btn = btns[i];
        btn.addEventListener("click", () => {
            // add btn class
            btn.classList.toggle("lr-product__btn-active");
            for (let i = 0; i < tabs.length; i++) {
                const tab = tabs[i];
                if (btn.id === tab.id) {
                    // show tab
                    tab.style.display = "block";
                } else {
                    // hide tab
                    tab.style.display = "none";
                    // remove btn class
                    btns[i].classList.remove("lr-product__btn-active");

                    // for (let i = 0; i < btns.length; i++) {
                    //   if (btns[i].id == tab.id) {
                    //     // btns[i].classList.remove("lr-product__btn-active");
                    //   }
                    // }
                }
            }
        });
    }
}

productAccordion();

/**
 * @function mobileReviewAccordion
 * @description accordion to show next element on mobile
 */
function mobileReviewAccordion() {
    const btns = document.querySelectorAll(".lr-review-mobile-accordion__btn");
    const content = document.querySelectorAll(
        ".lr-review-mobile-accordion__content"
    );

    for (let i = 0; i < btns.length; i++) {
        const btn = btns[i];

        btn.addEventListener("click", () => {
            if (btn.classList.contains("lr-mobile-accordion__active")) {
                btn.classList.remove("lr-mobile-accordion__active");
                btn.nextElementSibling.style.display = "none";

                btn.getElementsByTagName("span")[0].style.display = "none";
                btn.getElementsByTagName("span")[1].style.display = "block";
            } else {
                btn.classList.toggle("lr-mobile-accordion__active");
                btn.nextElementSibling.style.display = "block";

                btn.getElementsByTagName("span")[0].style.display = "block";
                btn.getElementsByTagName("span")[1].style.display = "none";
            }
        });
    }
}

mobileReviewAccordion();

/**
 * @description initialise function when dom loads
 */
document.addEventListener(
    "DOMContentLoaded",
    function () {
        getMetric();
        changeMetrics();
    },
    false
);

/**
 * @function getMetric
 * @description handle metric changes when DOM loads
 */

/*
function getMetric() {
  if (!localStorage.getItem("metric")) {
    localStorage.setItem("metric", "cm");
  } else {
    if (localStorage.getItem("metric") === "cm") changeMetrics();
    if (localStorage.getItem("metric") === "ft") changeMetrics();
  }

  const btns = document.querySelectorAll(".metric-btns > div");

  btns.forEach((btn) => {
    if (btn.innerText === localStorage.getItem("metric")) {
      btn.style.pointEvents = "none";
      btn.style.background = "red";
    } else {
      btn.style.pointEvents = "auto";
      btn.style.background = "black";
    }
  });
}
*/


async function assignDefaultMetrics() {
    const path = location.pathname;
    const res = await fetch(`${path}.json`);
    const json = await res.json();

    const sizesCM = [];
    const sizesFT = [];
    json.product.variants.map((product) => {
        const title = product.title || "";
        const matches = title.match(/\d+/g);

        if (!matches || matches.length < 2) {
            sizesCM.push(title);
            sizesFT.push(title);
            return;
        }

        const firstCm = parseInt(matches[0], 10);
        const secondCm = parseInt(matches[1], 10);

        const size0 = `${firstCm} cm`;
        const size2 = `${secondCm} cm`;
        sizesCM.push(`${size0} x ${size2}`);

        const formatFeetAndInches = (cm) => {
            const totalInches = cm / 2.54;
            const feet = Math.floor(totalInches / 12);
            const inches = Math.round(totalInches - feet * 12);
            return `${feet}' ${inches}"`;
        };

        const firstSize = formatFeetAndInches(firstCm);
        const secondSize = formatFeetAndInches(secondCm);
        sizesFT.push(`${firstSize} x ${secondSize}`);
    });

    let store = localStorage.getItem("metric");
    const sizes = document.querySelectorAll(".lr-main-product-value");
    sizes.forEach((size, index) => {
        //     size.innerText = this.sizesinFeet[index]
        if (store === "cm") {
            size.innerText = sizesCM[index];
        } else if (store === "ft") {
            size.innerText = sizesFT[index];
        }
    });
}

/**
 * @function changeMetrics
 * @description handles button click to change metric
 * @param {*} m Metric Size
 */
/*
function changeMetrics() {
  const btns = document.querySelectorAll(".metric-btns > div");

  btns.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (btn.innerText === "ft") {
        localStorage.setItem("metric", "ft");
      } else if (btn.innerText === "cm") {
        localStorage.setItem("metric", "cm");
      }
      assignDefaultMetrics();
      handleSizeBtnColours();
    });
  });
}
*/

/**
 * @function handleSizeBtnColours
 * @description Handles the colour switcher event when a btn is clicked
 */
/*
function handleSizeBtnColours() {
  const btns = document.querySelectorAll(".metric-btns > div");
  btns.forEach((btn) => {
    if (btn.innerText === localStorage.getItem("metric")) {
      btn.style.pointEvents = "none";
      btn.style.background = "red";
    } else {
      btn.style.pointEvents = "auto";
      btn.style.background = "black";
    }
  });
}
 */

/////new converter
function getMetric() {
    let metric = localStorage.getItem("metric") || "cm";
    localStorage.setItem("metric", metric); // Ensure metric is set in localStorage

    updateConverterUI(metric);
}

function updateConverterUI(metric) {
    const converter = document.querySelector(".custom-converter");
    if (!converter) return;
    converter.classList.toggle("active", metric === "ft");
}

function changeMetrics() {
    const converterSwitch = document.querySelector(".custom-converter .switch");
    if (!converterSwitch) return;
    assignDefaultMetrics();

    converterSwitch.addEventListener("click", () => {
        let currentMetric = localStorage.getItem("metric") === "cm" ? "ft" : "cm";
        localStorage.setItem("metric", currentMetric);
        assignDefaultMetrics(); // Update sizes display based on the new metric
        updateConverterUI(currentMetric); // Update the UI to reflect the current metric
    });
}
